<template>
  <div>
    <ul
      v-if="getAttachment(attachments, ['CV', 'COVER_LETTER'])"
      class="
        d-flex
        py-1 px-2
      "
      style="gap: 16px; border-radius: 10px; border: 1px dashed #f44336; list-style: none;"
    >
      <li
        v-if="getAttachment(attachments, 'CV')"
        class="px-2"
      >
        <v-btn
          class="px-0 "
          text
          :disabled="!canPerformAction(`VIEW_${permission}`)"
          @click="openFile(getAttachment(attachments, 'CV'))"
        >
          <v-icon color="primary" class="mr-2">mdi-file</v-icon>
          <span class="text-decoration-underline">CV</span>
        </v-btn>

        <v-btn
          icon
          :disabled="!canPerformAction(`VIEW_${permission}`)"
          @click="viewFile(getAttachment(attachments, 'CV'))"
        >
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </li>
      <li
        v-if="getAttachment(attachments, 'COVER_LETTER')"
      >
        <v-btn
          class="px-2"
          text
          :disabled="!canPerformAction(`VIEW_${permission}`)"
          @click="openFile(getAttachment(attachments, 'COVER_LETTER'))"
        >
          <v-icon color="primary" class="mr-2">mdi-file</v-icon>
          <span class="text-decoration-underline">COVER_LETTER</span>
        </v-btn>

        <v-btn
          icon
          :disabled="!canPerformAction(`VIEW_${permission}`)"
          @click="viewFile(getAttachment(attachments, 'COVER_LETTER'))"
        >
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </li>
    </ul>

    <v-dialog
      v-model="showDialog"
      max-width="1280"
    >
      <v-card
        min-height="100%"
        height="600px"
        max-height="100%"
      >
        <div
          v-if="!iframeLoaded"
          class="d-flex justify-center align-center fill-height col-12"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>

        <v-card-text
          class="fill-height pa-0 d-flex align-center justify-center"
        >
          <iframe
            v-if="googleViewerUrl"
            :key="componentRendered"
            :src="googleViewerUrl"
            class="col-12 pa-0"
            :class="{ 'd-none' : !iframeLoaded }"
            style="
              height: 100%;
              border: none;
            "
            allow="autoplay"
            allowfullscreen
            @load="iframeLoaded = true"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { requests } from '@/mixins/requests';

export default {
  name: 'TableAttachments',
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    permission: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      googleViewerUrl: null,
      showDialog: false,
      iframeLoaded: false,
      componentRendered: 0
    };
  },
  computed: {
    ...mapState([
      'activeWorkspace',
      'user'
    ]),
    ...mapGetters(['canPerformAction']),
    getAttachment () {
      return (attachments, tags) => [].concat(attachments).find(attachment => [].concat(tags).includes(attachment?.tag));
    }
  },
  methods: {
    async openFile (file) {
      if (!file) return;

      const { data } = await requests.downloadAttachment(file.path);

      const response = await fetch(data, { method: 'GET' }).then(r => r).catch(() => null);

      if (!response) {
        console.info('Erreur lors du téléchargement');
        return;
      }

      const blob = await response.blob();

      const newBlob = new Blob([blob]);

      const blobUrl = window.URL.createObjectURL(newBlob);

      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = file.description;

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      window.URL.revokeObjectURL(blobUrl);
    },
    async viewFile (file) {
      if (!file) return;

      // Get the file data
      const { data } = await requests.downloadAttachment(file.path);

      const response = await fetch(data, { method: 'GET' }).then(r => r).catch(() => null);

      if (!response) {
        console.info('Erreur lors du téléchargement');
        return;
      }

      this.googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(data)}&embedded=true`;

      this.iframeLoaded = false;
      this.showDialog = true;

      // Auto refresh until loaded
      const autoRefresh = () => {
        if (!this.iframeLoaded && this.showDialog) {
          this.componentRendered += 1;
          setTimeout(autoRefresh, 2000);
        }
      };

      // Start auto refresh
      setTimeout(autoRefresh, 2000);
    }
  }
};
</script>
